<template>
   <li class="news_item" @click="goDetail(item.id)">
    <div class="item_img">
      <img v-if="item.url" :src="item.url" object-fit="cover" alt="" />
      <img v-else :src="newsImg" alt="" />
    </div>
    <div class="item_info">
      <div class="info_top">
        <span class="info-title">{{ item.title }}</span>
        <span class="info-title2">{{ item.title2 }}</span>
        <span class="info-title3" @click.stop="callPhone(item.title3)">{{ item.title3 }}</span>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  data() {
    return {
      newsImg: require("../../../assets/imgs/newsImg.png"),
    };
  },
  props: {
    item: {
      type: Object,
      default: {},
    },
    value: {
      type: Number,
      default: null,
    },
  },

  methods: {
    goDetail(id) {
      this.$router.push(`/newsDetail/${id}`);
    },
    callPhone(phoneNumber) {
      console.log(phoneNumber);
      window.location.href = "tel://" + phoneNumber;
    },
    
  },
};
</script>

<style lang="scss" scoped>
.news_item {
  width: 100%;
  padding: 0.1rem 0.1rem;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  margin: 0.05rem 0;
  // height: 6rem;
  background: #fff;

  .item_img {
    width: 0.8rem;
    height: 0.8rem;
    margin-right: 0.07rem;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .item_info {
    flex: 1;

    .info_top {
      margin-bottom: 0.05rem;
      display: flex;
      flex-direction: column;

      .info-title {
        font-size: 0.16rem;
        font-weight: 600;
        color: #333333;
        line-height: initial;
      }

      .info-title2 {
        color: #666666;
        font-size: 0.13rem;
        margin-top: 0.08rem;
      }

      .info-title3 {
        color: #003edc;
        font-size: 0.13rem; 
        margin-top: 0.08rem;
      }
    }

    p {
      width: 2.17rem;
      height: 0.44rem;
      font-size: 12px;
      line-height: 0.15rem;
      color: $lightBlack;
    }
  }
}
</style>
